import { dateHelper, toEuropeanDate } from 'utils/helper';
import { visitWishReservationDate } from 'utils/visitWishReservation';
import { OPEN_STATUSES, VisitWish } from './visitWishApi';
import { filterOf } from './wishFilters';

export type Conversion = { label: string; hint: string; values?: Record<string, string>; possible: boolean };

/**
 * What the team can do to book an open wish: continue the reservation already
 * linked to it, or start one. A running exclusive offer must end first; a new
 * reservation never takes over the offered table.
 */
export const conversionOf = (wish: VisitWish, selectedDay?: string | null): Conversion | null => {
  if (!OPEN_STATUSES.includes(wish.status)) return null;
  const linked = wish.staffReservation;
  if (linked) {
    const values = { date: toEuropeanDate(linked.date), time: linked.time };
    return linked.state === 'protection_pending'
      ? {
          label: 'Open reservation',
          hint: 'The reservation for {{date}} at {{time}} already exists and is still waiting for its protection or confirmation.',
          values,
          possible: true,
        }
      : {
          label: 'Resume reservation',
          hint: 'A reservation for {{date}} at {{time}} is already being prepared from this wish. Resume it to check the details and save.',
          values,
          possible: true,
        };
  }
  if (filterOf(wish) === 'offer') {
    return {
      label: 'Convert to reservation',
      hint: 'An exclusive offer is running for this wish. Withdraw it before starting a separate reservation; that reservation cannot use the offered table.',
      possible: false,
    };
  }
  const date = visitWishReservationDate(wish, dateHelper(), selectedDay ?? undefined);
  return date
    ? {
        label: 'Convert to reservation',
        hint: 'Opens the reservation editor for {{date}} with this wish. Check the details there before saving.',
        values: { date: toEuropeanDate(date) },
        possible: true,
      }
    : { label: 'Convert to reservation', hint: 'No bookable day is left in this period.', possible: false };
};
